import { cn } from '@/lib/utils/tailwind';

import type { HTMLAttributes, ReactNode } from 'react';

type ModalBodyProps = HTMLAttributes<HTMLDivElement> & {
  children: ReactNode;
  className?: string;
};

const ModalBody = ({ children, className, ...props }: ModalBodyProps) => {
  return (
    <div className={cn(['p-4'], className)} {...props}>
      {children}
    </div>
  );
};

export { ModalBody };
